import * as React from 'react'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import i18n from 'modules/core/lib/i18n'

import type { FieldType } from 'modules/reports/components/Editor/Field/types'

interface Props {
  fieldType: FieldType
}

const OrderingOptions = ({ fieldType }: Props) => {
  const { form } = fieldType

  const options = [
    {
      value: 'asc',
      label: i18n.t('custom_reports.ordering_options.asc'),
    },
    {
      value: 'desc',
      label: i18n.t('custom_reports.ordering_options.desc'),
    },
  ]

  return (
    <Select
      none={i18n.t('custom_reports.ordering_options.no_order')}
      label={i18n.t('custom_reports.ability_labels.order_by')}
      field={form.get('order')}
      options={options}
    />
  )
}

export default observer(OrderingOptions)
